import {atom} from 'recoil';

export const declarationsCustomerMail = atom({
  key: 'declarationsCustomerMail',
  default: '',
});
